import { NgxSpinnerService } from "ngx-spinner";
import { NgxIndexedDBService } from "ngx-indexed-db";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { ICUser } from "../models/entities/icuser";
import { ICUserFilter } from "../models/filters/icuser.filter";
import { ICUserApi } from "../models/apis/icuser.api";
import { BaseUserService } from "./shared/base.user.service";

@Injectable()
export class ICUserService extends BaseUserService<
  ICUser,
  ICUserFilter,
  ICUserApi
> {
  constructor(
    public dbSrv: NgxIndexedDBService,
    public spinner: NgxSpinnerService,
    public http: HttpClient,
  ) {
    super(dbSrv, spinner, http, ICUser);
    this.EndPoint = "icuser";
  }
}
